export default __webpack_public_path__ + "static/media/help.8adc7a70.svg";